import { motion } from 'framer-motion';
import { FC, useId } from 'react';

interface BoredSVGProps {
	width?: number | string;
	height?: number | string;
}

/**
 * Bored state SVG - uses crossfade transition as the rotated pose
 * is too different for smooth part-based animation
 */
export const BoredSVG: FC<BoredSVGProps> = ({ width, height }) => {
	const id = useId();
	const clip0 = `clip0_bored_${id}`;
	const clip1 = `clip1_bored_${id}`;

	return (
		<motion.svg width={width} height={height} viewBox="0 0 316 278" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath={`url(#${clip0})`}>
				<rect width="316" height="278" fill="white" />
				<path d="M233 172.284C240.522 177.547 259.193 185.242 273.701 173.917" stroke="#3C3F49" strokeWidth="5" strokeLinecap="round" />
				<circle cx="5" cy="5" r="4.5" transform="matrix(0.774734 -0.632287 -0.632287 -0.774734 272.601 181.269)" fill="#3C3F49" stroke="#3C3F49" />
				<g style={{ mixBlendMode: 'multiply' }}>
					<path
						d="M146.101 247.015L182.606 219.776C184.771 218.161 186.428 215.959 187.38 213.431C190.132 206.127 186.442 197.974 179.137 195.222L176.734 194.317C174.453 193.457 172.011 193.107 169.58 193.292L133.663 196.023C131.33 196.2 129.025 196.65 126.797 197.363L120.053 199.521C110.945 202.434 104.049 209.936 101.91 219.256C98.4402 234.377 108.358 249.317 123.64 251.989L124.559 252.15C132.141 253.475 139.933 251.618 146.101 247.015Z"
						fill="#DBDFE6"
					/>
				</g>
				<g clipPath={`url(#${clip1})`}>
					<rect x="239.707" y="118" width="100" height="162" rx="32" transform="rotate(90 239.707 118)" fill="#FBDE8E" />
					<path
						d="M222.707 199C236.618 187.649 240.374 157.137 240.707 147C240.707 226.534 240.707 222.635 162.754 228.873C104.54 233.531 81.0474 211.756 79.2629 203.13C79.0692 202.194 79.8659 201.495 80.8218 201.495C122.732 201.504 207.398 211.493 222.707 199Z"
						fill="#FCC84F"
					/>
					<g style={{ mixBlendMode: 'multiply' }}>
						<rect x="161.707" y="118" width="100" height="15" transform="rotate(90 161.707 118)" fill="#515661" />
					</g>
					<g style={{ mixBlendMode: 'multiply' }}>
						<rect x="132.707" y="118" width="100" height="15" transform="rotate(90 132.707 118)" fill="#515661" />
					</g>
					<g style={{ mixBlendMode: 'multiply' }}>
						<rect x="103.707" y="118" width="100" height="15" transform="rotate(90 103.707 118)" fill="#515661" />
					</g>
					<rect x="206.162" y="128.5" width="10.4139" height="16.6623" rx="5.20697" transform="rotate(90 206.162 128.5)" fill="#3C3F49" />
				</g>
				<path
					d="M58.2909 211.056C61.1796 209.016 65.9341 207.39 70.4248 206.25C74.0251 205.335 76.1107 201.379 74.5186 198.023C73.2025 195.249 69.8427 194.06 67.5159 196.064C62.9561 199.991 59.553 205.738 57.456 210.38C57.0022 211.385 57.3904 211.692 58.2909 211.056Z"
					fill="#3C3F49"
				/>
				<path d="M233.037 194.177C239.282 200.906 255.914 212.359 272.481 204.344" stroke="#3C3F49" strokeWidth="5" strokeLinecap="round" />
				<circle cx="5" cy="5" r="4.5" transform="matrix(0.890511 -0.454961 -0.454961 -0.890511 271.194 210.616)" fill="#3C3F49" stroke="#3C3F49" />
				{/* Animated ZZZ thought bubble */}
				<motion.path
					d="M187.981 98.5223C185.873 93.5779 184.693 90.0255 188.876 85.6075C192.398 81.8863 199.06 77.2351 202.887 82.5516C204.823 85.241 203.403 85.4781 200.415 86.6562C197.226 87.9134 195.085 85.4735 193.963 82.8417C192.056 78.3681 194.428 75.3895 197.863 72.2597C201.43 69.0093 204.62 67.2103 208.358 70.703C211.803 73.9213 204.241 72.9298 202.722 71.9454C199.645 69.952 198.045 65.5966 200.479 62.7553"
					stroke="#A6ACB5"
					strokeWidth="3"
					strokeLinecap="round"
					fill="none"
					initial={{ pathLength: 0, opacity: 0 }}
					animate={{ pathLength: 1, opacity: 1 }}
					transition={{ duration: 1.5, ease: 'easeOut', delay: 0.3 }}
				/>
				<path d="M157.747 201.312L162.068 170.5" stroke="#FCC84F" strokeWidth="18.2362" strokeLinecap="round" />
			</g>
			<defs>
				<clipPath id={clip0}>
					<rect width="316" height="278" fill="white" />
				</clipPath>
				<clipPath id={clip1}>
					<rect x="239.707" y="118" width="100" height="162" rx="32" transform="rotate(90 239.707 118)" fill="white" />
				</clipPath>
			</defs>
		</motion.svg>
	);
};
